import { AxiosResponse } from 'axios';
import api from './Api'


export const requestSendAuthCodeCheck = (authCode: string): Promise<AxiosResponse<boolean, any>> => {
        return api.get(`/auth/code/${authCode}`);
}